import { motion } from "framer-motion";
import "../../styles/Plans.css";
import { useEffect, useContext } from "react";
import axios from "axios";
import { useState } from "react";
import BASE_URL from "../../BaseUrl";
import { GlobalContext } from "../GlobalContext";
export default function AdminPlansPage({setActive}) {

  const {admin} = useContext(GlobalContext);
  const [plans,setPlans] = useState([]);
  const [showBuyingSteps, SetShowBuyingSteps] = useState(false);
  const [message, setMessage] = useState("");

  const fetchPlans = ()=>{
      axios.get(`${BASE_URL}/teacher/plans`,{withCredentials:true})
      .then((response)=>{
        setPlans(response.data);
      }).catch((error)=>{
        console.log(error);
      })
  }

    useEffect(()=>{
        setActive("الملف الشخصي");
        fetchPlans();
    },[])
  function whatsappMessage(plan){
    setMessage(`الاسم :${admin.name}
البريد الاكتروني: ${admin.email}
تفاصيل الخطة:
اسم الخطة : ${plan.name}
${plan.capacity} درس
${plan.students} طالب
${plan.assistants} مساعد
سأقوم بدفع ثمن الاشتراك لهذه الخطة وهو ${plan.price} ج.م`)

  }
  return (
    <div className="page-plans-container">
      <h1 className="text-3xl font-bold text-center mb-10 text-purple-700">
        اختر خطة اسعارك
      </h1>

      {/* Small Cards */}
      <div className="plans-container">
        {plans.map((plan, i) => (
          <motion.div
            key={plan.id}
            initial={{ opacity: 0, x: 70 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{opacity:0, x:70}}
            transition={{ delay: i * 0.1 }}
          >
            <div className="plan-card">
              <h2 className="text-lg font-bold text-purple-600 mb-2">
                {plan.name}
              </h2>
              <p className="text-gray-600 text-sm">📦 {plan.capacity} درس</p>
              <p style={{width:"130%"}} className="text-gray-600 text-sm">👨‍🎓 {plan.students} طالب</p>
              <p className="text-gray-600 text-sm">👩‍🏫 {plan.assistants} مساعد</p>

              <div className="prices" onClick={()=>{
                whatsappMessage(plan);
                SetShowBuyingSteps(true);
              }}>    
                
                <p className="text-xl font-bold text-green-600"
                style={{
                    fontSize:"larger",
                    fontWeight:"bolder"
                }}>ج.م{plan.price}</p>
                <p className="line-through text-gray-400 text-sm"
                style={{textDecoration:"line-through", fontSize:"small", paddingTop:"4px",marginTop:"-20px", fontWeight:"lighter"}}
                >ج.م{plan.oldPrice}</p>
              </div>

              
            </div>
          </motion.div>
        ))}


        {showBuyingSteps&&(
            <div className="overlay">
            <div class="steps-container">
              <button class="close-btn" onClick={()=>{SetShowBuyingSteps(false)}}
                style={{zIndex:"999"}}>x</button>
                    <div class="steps-header">خطوات الإشتراك</div>

                    <div class="step">
                    <div class="step-number">الخطوة 1</div>
                    <p>قم بإرسال تفاصيل الخطة إلى المالك</p>
                    <a class="whatsapp-btn" 
                        href={`https://wa.me/201030452252?text=${encodeURIComponent(message)}`} 
                        rel="noreferrer"
                        target="_blank">
                        إرسال عبر واتساب
                    </a>
                    </div>

                    <div class="step">
                    <div class="step-number">الخطوة 2</div>
                    <p>قم بتحويل المبلغ لهذا الرقم <b>01030452252</b> عن طريق إنستاباي أو فودافون كاش</p>
                    </div>

                    <div class="step">
                    <div class="step-number">الخطوة 3</div>
                    <p>قم بإرسال صورة الإيصال على الواتساب وسيتم تفعيل الخدمة خلال 24 ساعة</p>
                    </div>
                </div>
                </div>
                        )}
                    </div>
            </div>
  );
}
